/**
 * LogoCard — Logo asset card with star, delete, edit, more buttons.
 */

export default function LogoCard({ asset, selected, onToggle, onSelect, starred, onStar, onMoreLike, onEdit, onDelete, generating }) {
  const src = asset.thumbnail_url || asset.file_url;
  const isApproved = asset.status === 'approved';
  return (
    <div className={`border-2 rounded-xl p-3 transition-all relative ${isApproved ? 'border-green-500 bg-green-50 ring-2 ring-green-200' : selected ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-200' : 'border-gray-200 hover:border-gray-300'}`}>
      {/* Current badge */}
      {isApproved && (
        <div className="absolute top-2 left-1/2 -translate-x-1/2 z-10 text-[10px] font-bold text-green-700 bg-green-100 px-2.5 py-0.5 rounded-full border border-green-300">
          Current Logo
        </div>
      )}
      {/* Generating overlay */}
      {generating && (
        <div className="absolute inset-0 bg-white/80 rounded-xl flex flex-col items-center justify-center z-10">
          <div className="w-8 h-8 animate-spin rounded-full border-2 border-gray-200 border-t-indigo-600 mb-2" />
          <span className="text-xs text-indigo-600 font-medium">Generating variants...</span>
        </div>
      )}
      <div className="flex justify-between mb-1">
        <div className="flex items-center gap-1.5">
          <button onClick={() => onStar(asset.id)} className={`text-lg leading-none transition-colors ${starred ? 'text-yellow-400' : 'text-gray-300 hover:text-yellow-300'}`} title={starred ? 'Unstar' : 'Star'}>
            {starred ? '\u2605' : '\u2606'}
          </button>
          <button onClick={() => onDelete(asset.id)} className="text-gray-300 hover:text-red-400 transition-colors" title="Delete">
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
          </button>
        </div>
        <input type="checkbox" checked={selected} onChange={() => onToggle(asset.id)} className="w-4 h-4 text-blue-600 rounded" />
      </div>
      <div className="aspect-square bg-gray-50 rounded-lg flex items-center justify-center overflow-hidden mb-2">
        {src ? <img src={src} alt="Logo" className="max-w-full max-h-full object-contain" /> :
         asset.content?.startsWith('<svg') ? <div dangerouslySetInnerHTML={{ __html: asset.content }} className="max-w-[80%]" /> :
         <span className="text-gray-300 text-sm">No preview</span>}
      </div>
      <div className="flex gap-1 mt-2">
        <button onClick={() => onSelect(asset.id)} className="flex-1 text-[10px] py-1.5 bg-gray-900 text-white rounded-lg hover:bg-gray-700">
          Use This
        </button>
        <button onClick={() => onEdit(asset.id)} disabled={generating} className="text-[10px] px-2 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-40">
          Edit
        </button>
        <button onClick={() => onMoreLike(asset.id)} disabled={generating} className="text-[10px] px-2 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-40">
          More
        </button>
      </div>
    </div>
  );
}
